export default __webpack_public_path__ + "static/media/analyze_tractor.5c98a208.jpg";